export const DOMAIN = {
  ADJUST_INVENTORY: 204,
  CALENDAR: -44,
  CREDIT: -56,
  DELIVERY_METHOD: -30,
  GOOD: -33,
  OTHER_CHARGE: -34,
  SERVICE: -7,
  TAX: -25,
  AUTOMATED_CREATE: 305,
  AUTOMATED_TASK: 304,
  BALANCE_SHEET: 59,
  BANKING: 177,
  CALENDAR_EVENT: 190,
  CATEGORIES: 3,
  CHART_ACCOUNT: 58,
  CHECK_LAYOUT: -58,
  CHECK: -57,
  CHECK_USER: -74,
  CLASSIFICATION: -41,
  CLIENT: 76,
  COMMENTS: 0,
  COMPANY_SETTING: -12,
  CONVERT_PAYABLES: 215,
  COPY_PAYABLES: 213,
  CREDIT_INFORMATION_REPORT: -42,
  CREDIT_MEMO: 56,
  CUSTOM_FIELD: -29,
  CUSTOMERS: 34,
  DEFAULT_TERMINOLOGY: 302,
  DEPOSIT: 48,
  DIRECTION: -5,
  DISCOUNT: -32,
  DRAWER: -1,
  EMAIL: 208,
  EMAIL_TEMPLATE: -21,
  EMPLOYEE: 17,
  ESTIMATE: 40,
  FIELDS: -6,
  FILE_MANAGEMENT: -40,
  FILE_COMMENTS: -46,
  UPLOAD_DOCUMENTS: 169,
  FIELD_SET: -23,
  FIXED_ASSET: 38,
  FOLDERS: -2,
  FUND_RECEIVED: 180,
  GENERATE_REPORT: 186,
  GOODS_RECEIVING: -54,
  IMPORTANT_DATES: 14,
  INVENTORY_ITEMS: 10,
  INVENTORY_RECEIVING_ITEMS: -50,
  INVENTORY_RECEIVING: -48,
  INVOICE_BUILDER: 301,
  INVOICE: 157,
  INVOICE_WRITE_OFF: 61,
  INVOICE_SETTING: -39,
  JOBS: 45,
  JOURNAL_ENTRY: 174,
  LAYOUT: -28,
  LEDGER: 56,
  MESSAGE: -26,
  MESSAGE_TEMPLATE: 211,
  MESSAGES: -3,
  NOTEPAD_VERSION: -51,
  NOTEPAD: 156,
  NOTIFICATION: -73,
  OTHER_CONTACT: 148,
  OTHER_FUNDS: -59,
  PAYABLE_BILL: 176,
  PAYABLE_CREDIT: 178,
  PAYABLE_AGING_PERIOD: 24,
  PAYABLE_AGING_SETTING: -69,
  PAYABLE_PROCESSING: 140,
  PAYMENT_METHOD: -55,
  PAYMENTS: -60,
  ACCT_PAYMENT: 36,
  PAYROLL_ITEMS: -17,
  PEOPLE: -43,
  PERMISSION: -38,
  PREVIEW_TO_BE_PAID: -67,
  PRINT_AUTH: -39,
  PRINT_CHECK: -70,
  PRINT_QUE: 194,
  PRIVATE_CONTACT: 149,
  PROSPECT: 145,
  PURCHASE_ORDER: 203,
  QUICK_NOTE: 25,
  RATE: -6,
  RECEIVABLE_ITEMS: 136,
  RECEIVABLE_PROCESSING: 137,
  REMINDER: -6,
  RETURN_ITEM: 200,
  REVIEW_CHECK: -68,
  REMINDER: -24,
  REVIEW_TO_BE_APPROVED: -66,
  SALES_RECEIPTS: 117,
  SCHEDULAR_GEM: 300,
  SCHEDULAR: 209,
  SECURE_ITEM: 214,
  SENT_EMAIL: 210,
  SERVICE_RECEIVING: -52,
  SETTINGS: -10,
  STATUS: 4,
  STORAGE: 166,
  TASK: 144,
  TASK_LIST: -13,
  TERM: -27,
  TERMINOLOGY: -11,
  TESTING_MODULE: 303,
  TEXT_EDITOR: -31,
  THEME_SETTING: 0,
  TO_BE_APPROVED: -64,
  TO_BE_ENTERED: -63,
  TO_BE_PAID: -65,
  TRANSACTION: -37,
  TYPES: 2,
  USERS: 89,
  VENDOR: 18,
  VIEWING_FILE_COMMENTS: -45,
  WAREHOUSE_LOCATION: -47,
  WAREHOUSE: -49,
  WEATHER_FORCAST: 25,
  WEBSITE: 25,
  WORK_ORDER: 171,
};
